var path = '/modules/action_log/components/entity-change-log/component.tpl.html';
var html = "<listview store=\"vm.store\" ng-if=\"vm.showStore\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/action_log/components/entity-change-log/component.tpl.html
// module id = 2052
// module chunks = 1